module.exports = __webpack_public_path__ + "img/APPdingzhi.b2c9119c.png";